/**
 * User Portal BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CalculateWithdrawalDetailsRequest { 
    accountId?: string | null;
    currencyId?: number;
    chainId?: number;
    recipientAddress?: string | null;
    amount?: number | null;
}

